/**
 * Workday Industry Taxonomy
 * Comprehensive industry classification aligned with Workday standards
 */

export const WORKDAY_INDUSTRIES = [
  // Technology & Software
  'Software & IT Services',
  'Information Technology',
  'Computer Software',
  'Internet & Web Services',
  'Cloud Computing & SaaS',
  'Cybersecurity',
  'Artificial Intelligence & Machine Learning',
  'Data Analytics & Business Intelligence',
  'Telecommunications',
  'Hardware & Networking',
  'Semiconductors & Electronics',
  
  // Financial Services
  'Banking & Financial Services',
  'Investment Banking',
  'Asset Management',
  'Insurance',
  'Venture Capital & Private Equity',
  'Accounting',
  'Financial Technology (FinTech)',
  'Real Estate & Property Management',
  
  // Healthcare & Life Sciences
  'Healthcare Services',
  'Hospitals & Medical Centers',
  'Pharmaceuticals',
  'Biotechnology',
  'Medical Devices & Equipment',
  'Health Insurance',
  'Mental Health & Wellness',
  
  // Manufacturing & Industrial
  'Manufacturing',
  'Automotive',
  'Aerospace & Defense',
  'Industrial Equipment & Machinery',
  'Chemical Manufacturing',
  'Food & Beverage Manufacturing',
  'Consumer Goods Manufacturing',
  'Textile & Apparel Manufacturing',
  
  // Retail & Consumer
  'Retail',
  'E-commerce',
  'Consumer Electronics',
  'Fashion & Apparel',
  'Food & Beverage Retail',
  'Luxury Goods',
  'Wholesale & Distribution',
  
  // Energy & Utilities
  'Oil & Gas',
  'Renewable Energy',
  'Utilities',
  'Mining & Metals',
  
  // Professional Services
  'Consulting',
  'Legal Services',
  'Human Resources & Staffing',
  'Marketing & Advertising',
  'Public Relations',
  'Management Consulting',
  'Business Services',
  
  // Education & Training
  'Education',
  'Higher Education',
  'K-12 Education',
  'E-Learning & EdTech',
  'Training & Development',
  
  // Media & Entertainment
  'Media & Publishing',
  'Entertainment & Gaming',
  'Film & Television Production',
  'Music & Audio',
  'Sports & Recreation',
  
  // Hospitality & Travel
  'Hospitality',
  'Hotels & Resorts',
  'Restaurants & Food Service',
  'Travel & Tourism',
  'Airlines',
  
  // Transportation & Logistics
  'Transportation',
  'Logistics & Supply Chain',
  'Shipping & Freight',
  'Warehousing',
  
  // Construction & Real Estate
  'Construction',
  'Architecture & Engineering',
  'Real Estate Development',
  'Property Management',
  
  // Government & Non-Profit
  'Government',
  'Non-Profit & NGO',
  'Public Administration',
  
  // Agriculture
  'Agriculture & Farming',
  'Food Production',
  
  // Other
  'Other'
];

export const COMPANY_FORMATION_TYPES = [
  'Sole Proprietorship or Individual',
  'C Corp',
  'S Corp',
  'Partnership',
  'Trust',
  'Estate',
  'LLC'
];

export const COMPANY_STATUS_OPTIONS = [
  'Qualified Lead',
  'Active Account',
  'DNC',
  'Archive'
];

export const COMPANY_SIZE_OPTIONS = [
  '1-10 employees',
  '11-50 employees',
  '51-100 employees',
  '101-500 employees',
  '501-1000 employees',
  '1001-5000 employees',
  '5001-10000 employees',
  '10000+ employees'
];

export const BILLING_FREQUENCY_OPTIONS = [
  'Weekly',
  'Bi-weekly',
  'Monthly',
  'Quarterly',
  'Per Placement',
  'Custom'
];

export const NET_TERMS_OPTIONS = [
  { value: 15, label: 'Net 15' },
  { value: 30, label: 'Net 30' },
  { value: 45, label: 'Net 45' },
  { value: 60, label: 'Net 60' },
  { value: 90, label: 'Net 90' }
];

export const CURRENCY_OPTIONS = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'MXN', symbol: 'Mex$', name: 'Mexican Peso' }
];
